<template>
<div>


    <div class="columns" >

        <div v-if="!isMobile()" class="column is-8 has-text-centered" style="background-color:white;">
            <img style="margin-top:10%" src="/static/22.png" alt="" srcset="" width="700">
        </div>

        <div class="column is-4" style="margin-top:0%;">

            <div class="login-container">
                <img src="/static/LOGO_1.png" alt="Logo" width="200">
                <!--  <img src="/static/logo 2.png" alt="Logo" width="200"> -->
                <p>Admin Login</p><br>
                <div class="card" style="width:80%">
                    <div class="card-content">
                        <!-- <div class="title is-size-3 has-text-left">Hello,</div>
                        <div class="title is-size-6 has-text-left" style="margin-top:-5%">Login to Learning Management System</div> -->
                        <b-field label="Email">
                            <b-input type="email" v-model="email"></b-input>
                        </b-field>
                        <b-field label="Password">
                            <b-input type="password" v-model="password"></b-input>
                        </b-field>
                        <p class="has-text-danger">{{error}}</p>

                        <b-button type="is-warning" expanded :class="{'is-loading': isLoading}" @click="login">Login</b-button>

                        <!-- <div class="subtitle has-text-centered is-size-7" style="margin-top:10px">
                            <b>Made with ❤️ in India <br> by ITM New Wave IT Labs, Mumbai</b>
                        </div> -->

                        <!-- <center style="padding-top:5px; color:black">
                            <router-link class="has-text-weight-bold	is-size-7" style="color:black;" to="/forgot">Forgot your password ?</router-link>
                        </center> -->

                    </div>

                </div>
                <!--   <img class="fix" src="/static/tb.jpg" >  -->

            </div>
        </div>
    </div>

  

</div>

</template>

<script>
import Firebase from '../../lib/Firebase';

export default {
    name: "login",

    data() {
        return {
            isLoading: false,
            email: process.env.NODE_ENV === "development" ? "viral@early-genius.com" : null,
            password: process.env.NODE_ENV === "development" ? "123456" : null,
            error: null,
            userdetail: null,
            data: null,
        };
    },

    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        login() {
            this.isLoading = true
            Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                (user) => {
                    console.log("1")
                    if (user.user && user.user.uid) {
                        console.log(user.user)
                        console.log(user.user.uid)
                        props: {
                            userprop: this.user
                        }
                        let docRef = Firebase.firestore().collection("users").doc(user.user.uid);
                        docRef.get().then(doc => {

                            if (doc.exists) {
                                let data = doc.data();
                                if (data.role === "admin") {
                                    console.log(data.role, user.user.email)
                                    this.isLoading = false;
                                    this.$router.push("/app/dashboard");

                                    /*  const firestoreDb = Firebase.firestore();
                                     const oldRealTimeDb = Firebase.database();

                                     const usersRef = firestoreDb.collection('users'); // Get a reference to the Users collection;
                                     const onlineRef = oldRealTimeDb.ref('.info/connected'); // Get a reference to the list of connections

                                     onlineRef.on('value', snapshot => {

                                         oldRealTimeDb
                                             .ref(`/status/${user.user.uid}`)
                                             .onDisconnect() // Set up the disconnect hook
                                             .set('offline') // The value to be set for this key when the client disconnects
                                             .then(() => {
                                                 // Set the Firestore User's online status to true
                                                 usersRef.doc(user.user.uid)
                                                     .set({
                                                         online: true,
                                                     }, {merge: true});

                                                 // Let's also create a key in our real-time database
                                                 // The value is set to 'online'
                                                 oldRealTimeDb.ref(`/status/${user.user.uid}`).set('online');
                                             });

                                     }); */

                                    var uid = Firebase.auth().currentUser.uid;
                                    var userStatusDatabaseRef = Firebase.database().ref('/users/' + user.user.uid);

                                    var isOfflineForDatabase = {
                                        state: 'offline',
                                        //last_changed: new Date(),
                                    };

                                    var isOnlineForDatabase = {
                                        state: 'online',
                                        //last_changed: new Date(),
                                    };

                                    // [END_EXCLUDE]
                                    var userStatusFirestoreRef = Firebase.firestore().doc('/users/' + user.user.uid);

                                    // Firestore uses a different server timestamp value, so we'll 
                                    // create two more constants for Firestore state.
                                    var isOfflineForFirestore = {
                                        state: 'offline',
                                        //last_changed: new Date(),
                                    };

                                    var isOnlineForFirestore = {
                                        state: 'online',
                                        //last_changed: new Date(),
                                    };

                                    Firebase.database().ref('.info/connected').on('value', function (snapshot) {
                                        if (snapshot.val() == false) {
                                            // Instead of simply returning, we'll also set Firestore's state
                                            // to 'offline'. This ensures that our Firestore cache is aware
                                            // of the switch to 'offline.'
                                            userStatusFirestoreRef.update(isOfflineForFirestore);
                                            return;
                                        };

                                        userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function () {
                                            userStatusDatabaseRef.set(isOnlineForDatabase);

                                            // We'll also add Firestore set here for when we come online.
                                            userStatusFirestoreRef.update(isOnlineForFirestore);
                                        });
                                    });

                                } else {
                                    console.log(data.role, user.user.email)
                                    this.isLoading = false;
                                    this.$toast.open({
                                        duration: 6000,
                                        message: `You are not Admin! Please contact Head Office!`,
                                        position: 'is-top',
                                        type: 'is-danger'
                                    })
                                    // alert('You are not admin!');
                                    console.log("No such document!");
                                }
                            }
                        })
                    }
                },
                (err) => {
                    alert('Oops. ' + err.message)
                    this.isLoading = false;

                }
            );
        },

    }
};
</script>

<style scoped>
img {
    margin-bottom: 1rem;
}

.login-container {
    background-color: #ffffff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: 300px;
    background-repeat: repeat-x;
    background-attachment: fixed;
    background-position: bottom;

    /*   background-image:
    url(/static/tb.jpg);  */
}

/* .background{
   height: 50px;

 background-repeat: repeat-y;
  margin-top: 0rem;
  
  border-radius: 50%;
} */
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue